<template>
  <div style="position: relative;">
    <NavBar :index="2" />
    <!-- 轮播图 -->
    <img class="top-nav" src="../assets/tops.png" alt="返回顶部" @click="topOne">
    <swiper :options="swiperOption" ref="mySwiper" id="mySwiper">
      <!-- 轮播图0 -->
      <swiper-slide class="swiper_slide_item">
        <swiper :options="swiperTop" ref="swiperTop" id="swiperTop">
          <swiper-slide>
            <div class="one-card" style=" border-radius: 0; position: relative; width: 100vw; height: 100vh;margin: 0;">
              <video src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/7ac98f165e1f3e8a2613b21dfd8ae348_raw.mp4"
                autoplay muted loop
                style="position: absolute; top: 0; left: 0; width: 100vw; height: 100%; object-fit: cover;"
                preload="auto">
              </video>
              <div class="textara">
                <div class="text-cons">智谷AI-您的全能智能助手！</div>
                <div class="text-fonts">智能AI对话、创作、模拟、绘画、翻译等功能,一站式解决您的所有需求!</div>
              </div>
              <!-- <div class="but-tex">解锁智谷AI体验</div> -->
            </div>
          </swiper-slide>
          <!--分页器-->
          <div class="top-pagination" slot="pagination"></div>
        </swiper>
        <!-- Tab 导航 - 使用与businessList相同的样式 -->
        <div class="top-business-con">
          <div class="tab-nav">
            <div v-for="(tab, index) in topTabs" :key="index" :class="['tab-item', { active: index === 0 }]"
              @click="switchTopTab(index)">
              {{ tab.name }}
            </div>
          </div>
        </div>
      </swiper-slide>
      <!--必须的组件-->
      <!--每页幻灯片使用swiper-slide标签-->
      <!-- 1 -->
      <swiper-slide class="swiper_slide_item">
        <div class="one-card">
          <div class="card-Tit " :class="activeIndex == 1 ? 'animated-news-item' : ''">超算公有链智谷链</div>
          <div class="card-font " :class="activeIndex == 1 ? 'animated-news-item' : ''">Wisdom Valley Electronic
            supercomputing Public chain(简称:WEC)</div>
          <!-- 内容 -->
          <div class="bigCards">
            <div class="tab-pane-content" :class="activeIndex == 1 ? 'animated-news-item' : ''">
              <div class="feature-list">
                <div class="feature-item">
                  <div class="feature-header">
                    <img src="../assets/aq.png" alt="">
                    <h4>安全</h4>
                  </div>
                  <p>国际标准开发,符合国家监管方向</p>
                </div>
                <div class="feature-item">
                  <div class="feature-header">
                    <img src="../assets/yyscs.png" alt="">
                    <h4>应用市场广</h4>
                  </div>
                  <p>以区块链技术为核心，打造底层应用公链，联盟构建平台</p>
                </div>
                <div class="feature-item">
                  <div class="feature-header">
                    <img src="../assets/scgqh.png" alt="">
                    <h4>市场高契合</h4>
                  </div>
                  <p>结合实体产业需求，定制数字功能模块</p>
                </div>
                <div class="feature-item">
                  <div class="feature-header">
                    <img src="../assets/lsqfw.png" alt="">
                    <h4>链上全服务</h4>
                  </div>
                  <p>链上产业、技术、资源互通，打造良性生态圈</p>
                </div>
              </div>
            </div>
            <!-- 右侧 -->
            <div class="right-image-content" :class="activeIndex == 1 ? 'animated-partner-row-delay1' : ''">
              <img src="../assets/csletf.png">
            </div>
          </div>
        </div>
      </swiper-slide>

      <!-- 智谷链十二大 2-->
      <swiper-slide class="swiper_slide_item">
        <div class="video-containers">
          <video ref="video1"
            src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/59c43894c5ca91121694ef340e54f470_raw.mp4" autoplay
            muted style="width: 100%; height: 100%; object-fit: cover;" preload="auto">
          </video>
          <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
            <div class="text-overlays" :class="activeIndex == 2 ? 'animated-news-item' : ''">智谷链十二大领先技术</div>
            <p class="subtitle" :class="activeIndex == 2 ? 'animated-news-item' : ''">领先技术，赋能经济</p>
          </div>
        </div>
      </swiper-slide>
      <!-- PASS数字服务平台 3 -->
      <swiper-slide class="swiper_slide_item">
        <div class="passBig">
          <div class="pass-font" :class="activeIndex == 3 ? 'animated-news-item' : ''">PAAS数字服务平台</div>
          <div class="bigSz">
            <img src="../assets/passsz.png" :class="activeIndex == 3 ? 'animated-news-item' : ''"></img>
          </div>
        </div>
      </swiper-slide>

      <!-- 多系统 4-->
      <swiper-slide class="swiper_slide_item">
        <div class="reds-tit">
          <div :class="activeIndex == 4 ? 'animated-news-item' : ''">多系统融合数字生态服务</div>
        </div>
        <div class="bgcAll">
          <div
            style="display: flex;width: 70%; z-index: 999999999; margin-left: 15%;justify-content:space-between;position: absolute;bottom:50px;">
            <div class="leftbgc" :class="activeIndex == 4 ? 'animated-news-item' : ''">
              <p>数字经济生态平台</p>
              <div class="left-font">
                <div class="rediceItem-content">
                  <div class="rediceItem-content-notice"> <span class="rediceItem-content-round">●</span>
                    Baas微服务云部署【存证底层系统】</div>
                  <div class="rediceItem-content-notice"> <span class="rediceItem-content-round">●</span>
                    Paas中台数据云部署【通证底层系统】</div>
                  <div class="rediceItem-content-notice"> <span class="rediceItem-content-round">●</span>ABCDI【元宇亩服务系统】
                  </div>
                </div>
              </div>
            </div>
            <div class="rightBgc" style="position: relative;z-index: 999999999;"
              :class="activeIndex == 4 ? 'animated-partner-row-delay1' : ''">
              <p>行业落地应用案例</p>
              <div class="right-font">
                <div class="rediceItem-contents">
                  <div class="rediceItem-content-titles">1.提供</div>
                  <div style="display: flex;justify-content: space-around; padding-right: 70px;">
                    <div class="rediceItem-content-notices"> <span class="rediceItem-content-rounds">●</span>
                      区块链服务平台</div>
                    <div class="rediceItem-content-notices"> <span class="rediceItem-content-rounds">●</span>
                      一站式服务</div>
                  </div>
                  <div class="rediceItem-content-titles">
                    2.解决方案</div>
                  <div style="display: flex;justify-content: space-around; padding-right: 70px;">
                    <div class="rediceItem-content-notices"> <span class="rediceItem-content-rounds">●</span>
                      智慧园区数字化</div>
                    <div class="rediceItem-content-notices"> <span class="rediceItem-content-rounds">●</span>
                      数字版权可信存证</div>
                  </div>
                  <div class="rediceItem-content-notices"> <span class="rediceItem-content-rounds">●</span>
                    供应链金融应收账融资抵押
                  </div>
                  <div class="rediceItem-content-titles">3.实现</div>
                  <div class="rediceItem-content-notices"><span class="rediceItem-content-rounds"
                      style="padding-bottom: 20px;">●</span>区块链网络的快速部暑和维护智能合约和业务模式的快速落地
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img src="../assets/csbuto.png" style="width: 100%;height: 10%;position: absolute;bottom: 0;z-index: 9999;"
            alt="">
        </div>
      </swiper-slide>
      <!-- 链改服务内容 5 -->
      <swiper-slide class="swiper_slide_item">
        <div style="padding-top: 50px;">
          <div class="video-ref">
            <video ref="video2"
              src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/%E9%93%BE%E6%94%B9%E6%9C%8D%E5%8A%A1%E5%86%85%E5%AE%B9.mp4"
              autoplay muted style="width:100vw; height: 90vh; object-fit: contain;" preload="auto">
            </video>
            <div class="video-overlay">
              <div class="reform-con" :class="activeIndex == 5 ? 'animated-news-item' : ''">
                链改服务内容
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 十三大解决企业痛点 6 -->
      <swiper-slide class="swiper_slide_item">
        <div>
          <div class="video-td">
            <video ref="video3"
              src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/%E5%8D%81%E4%B8%89%E5%A4%A7%E8%A7%A3%E5%86%B3%E4%BC%81%E4%B8%9A%E7%97%9B%E7%82%B9.mp4"
              autoplay muted style="width: 100vw; height: 100vh; object-fit: cover;" preload="auto">
            </video>
            <div class="video-tds">
              <div class="td-con" :class="activeIndex == 6 ? 'animated-news-item' : ''">
                十三大解决企业痛点
              </div>
              <p class="td-tit" :class="activeIndex == 6 ? 'animated-news-item' : ''">解决企业数字化转型升级难点痛点</p>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 链改服务内容 7 -->
      <swiper-slide class="swiper_slide_item">
        <div class="lg-fuwu">
          <div class="lg-font">智慧谷链改平台</div>
          <div class="lg-bigs">
            <div class="lg-zi">
              <img src="../assets/lgy.png" alt="" :class="activeIndex == 7 ? 'fade-in-1' : ''" />
              <img src="../assets/lge.png" alt="" :class="activeIndex == 7 ? 'fade-in-2' : ''" />
              <img src="../assets/lgs.png" alt="" :class="activeIndex == 7 ? 'fade-in-3' : ''"
                style="min-width: 120px;max-width: 240px; height: 480px;" />
              <img src="../assets/lgss.png" alt="" :class="activeIndex == 7 ? 'fade-in-4' : ''" />
              <img src="../assets/lgw.png" alt="" :class="activeIndex == 7 ? 'fade-in-5' : ''" />
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 4 -->
      <!-- 4 核心业务 8 -->
      <swiper-slide class="swiper_slide_item">
        <div class="aixt-con">
          <div class="ai-fon">
            <div class="xt-ft" :class="activeIndex == 8 ? 'animated-news-item' : ''">5.0数商生态平台|AI电商生态系统</div>
            <div class="xt-txt" :class="activeIndex == 8 ? 'animated-news-item' : ''">智谷链 企链通 有爱、有链、有未来!</div>
          </div>
          <div class="aixt-big">
            <div style="display: flex;align-items: center;justify-content: space-around;width: 100%; ">
              <div class="aixt-left"><img src="../assets/shuz.png" alt=""
                  :class="activeIndex == 8 ? 'animated-news-item' : ''"></div>
              <div class="aixt-right" :class="activeIndex == 8 ? 'animated-partner-row-delay1' : ''">
                <div class="aixt-tit">企链通简介</div>
                <div>
                  <div class="aixt-font">
                    企链通是智慧谷旗下的一款基于自主区块链技术开发的数字商城生态系统。该应用构建数字生态系统,整合AI商城、社群服务、资讯中心、智谷AI助手、AI名片、数字钱包、积分通兑等多功能模块，以满足用户多元化需求。
                  </div>
                  <div class="more-btn" @click="goToExternalLink">
                    查看更多 <span class="arrow">→</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>

      <!-- 企链通十大应用功能 9-->
      <swiper-slide class="swiper_slide_item">
        <div class="qlt-sd">
          <div class="qlt-Tit" :class="activeIndex == 9 ? 'animated-news-item' : ''">企链通十大应用功能</div>
          <div class="qlt-big">
            <div class="qlt-row" :class="activeIndex == 9 ? 'animated-news-item' : ''">
              <div class="qlt-back">
                <img src="../assets/sjgj.png" alt="" class="qlt-img">
                <div class="qlt-txt">社交工具</div>
                <div class="qlt-con">是一款链接360行的AI名片社交工具;</div>
              </div>
              <div class="qlt-back">
                <img src="../assets/tkxt.png" alt="" class="qlt-img">
                <div class="qlt-txt">拓客系统</div>
                <div class="qlt-con">是一款5.0AI电商自动带货拓客系统;</div>
              </div>
              <div class="qlt-back">
                <img src="../assets/passxt.png" alt="" class="qlt-img">
                <div class="qlt-txt">PaaS系统</div>
                <div class="qlt-con">是一款超级轻量化DApp-PaaS系统;</div>
              </div>
              <div class="qlt-back">
                <img src="../assets/dfgj.png" alt="" class="qlt-img">
                <div class="qlt-txt">兑付工具</div>
                <div class="qlt-con">是一款全球首创“数字红包”兑付工具;</div>
              </div>
              <div class="qlt-back">
                <img src="../assets/bbgj.png" alt="" class="qlt-img">
                <div class="qlt-txt">必备工具</div>
                <div class="qlt-con">是一款中小企业数字化转型升级必备工具;</div>
              </div>
            </div>
            <div style="height: 70px;"></div>
            <div class="qlt-row" :class="activeIndex == 9 ? 'animated-partner-row-delay1' : ''">
              <div class="qlt-back">
                <img src="../assets/sassxt.png" alt="" class="qlt-img">
                <div class="qlt-txt">SaaS系统</div>
                <div class="qlt-con">是一款企业数据采集、上链、确权等功能的SaaS系统;</div>
              </div>
              <div class="qlt-back">
                <img src="../assets/kfpt.png" alt="" class="qlt-img">
                <div class="qlt-txt">开放平台</div>
                <div class="qlt-con">是一款集数字生活，商城，支付，社交，资讯等于一身的开放平台;</div>
              </div>
              <div class="qlt-back">
                <img src="../assets/stxt.png" alt="" class="qlt-img">
                <div class="qlt-txt">生态系统</div>
                <div class="qlt-con">是一款链接宗东、美团、拼多多等头部API接口的数字生态系统;</div>
              </div>
              <div class="qlt-back">
                <img src="../assets/jsxt.png" alt="" class="qlt-img">
                <div class="qlt-txt">结算系统</div>
                <div class="qlt-con">是一款跨国界、跨行业跨领域的积分通存通兑结算系统;</div>
              </div>
              <div class="qlt-back">
                <img src="../assets/qbxt.png" alt="" class="qlt-img">
                <div class="qlt-txt">钱包系统</div>
                <div class="qlt-con">是一款集聚合支付+数证分账等多功能超级钱包系统;</div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 企链通十三大创新技术10 -->
      <swiper-slide class="swiper_slide_item">
        <div class="video-st">
          <video ref="video4"
            src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/3bbfd25fe803e6b2b028ebf39c368de1_raw.mp4" autoplay
            muted
            style="width: 100%; height: 90vh; display: flex;align-items: center;justify-content: center; object-fit:contain;"
            preload="auto">
          </video>
          <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
            <div class="text-overlays" :class="activeIndex == 10 ? 'animated-news-item' : ''">企链通十三大创新技术</div>
          </div>
        </div>
      </swiper-slide>
      <!-- 智慧谷AI名片是什么? 11-->
      <swiper-slide class="swiper_slide_item">
        <div class="video-zgai">
          <video ref="video5"
            src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/668766efe05bb0ba40122b6cf0f623a7_raw.mp4" autoplay
            muted style="width: 100%; height: 100%; object-fit: cover; margin-top: 60px;" preload="auto">
          </video>
          <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <div class="zgaish" :class="activeIndex == 11 ? 'animated-news-item' : ''">智慧谷AI名片是什么?</div>
            <p class="zgai-tex" :class="activeIndex == 11 ? 'animated-news-item' : ''">
              智慧谷AI名片是一款综合性的商务工具。利用大数据+3D技术+AI人工智能技术,集合了3D动感名片、智谷AI助手、
              AI商城、数字人等多功能于一体,旨在为用户提供更加便捷、高效、智能的商务体验和商务持。智慧谷AI名片设有企业版，帮助企业破解获客难、转化低、管理散等痛点。
              <span @click="goToAICard" style="color: #0066FF; cursor: pointer;">查看更多 <span
                  class="arrow-right">→</span></span>
            </p>
          </div>
        </div>
      </swiper-slide>
        <!-- 新加 -->
        <swiper-slide class="swiper_slide_item">
        <div class="new-slide-container">
            <div class="new-slide-title" :class="activeIndex == 12 ? 'animated-news-item' : ''">数购通推客系统</div>
            <p class="new-slide-text" :class="activeIndex == 12 ? 'animated-news-item' : ''">
              智打造覆盖“流量-留存-转化-增长-生态”的全链路商业解决方案，直击企业流量获取难、留存低、盈利单一、供应链弱等核心痛点，为传统企业数字化转型、创业者轻资产入局提供一站式增长引擎,点击<span  class="view-more-link" style="cursor: pointer;" @click="gowebviews">了解更多 <span class="arrow-right">→</span></span>
            </p>
          </div>
          <div class="new-con">
            <div class="new-two" :class="activeIndex == 12 ? 'animated-news-item' : ''">
              <img src="../assets/sgyu.png" alt="">
              <img src="../assets/sger.png" alt="">
            </div>
            <div class="new-two" :class="activeIndex == 12 ? 'animated-partner-row-delay1' : ''">
              <img src="../assets/sgsan.png" alt="">
              <img src="../assets/sgsi.png" alt="">
            </div>
            <div class="new-two" :class="activeIndex == 12 ? 'animated-news-item' : ''">
              <img src="../assets/sgwu.png" alt="">
              <img src="../assets/sgqi.png" alt="">
            </div>
          </div>
      </swiper-slide>
      <!-- 申请智慧名片13 -->
      <swiper-slide class="swiper_slide_item">
        <div class="video-zhmp">
          <video ref="video7"
            src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/46eaab223b1b69f66072efaffad5f215_raw.mp4" autoplay
            muted style="width: 100vw; height: 95vh; object-fit: contain;" preload="auto">
          </video>
        </div>
      </swiper-slide>
        <!-- 只需要8步14 -->
        <swiper-slide class="swiper_slide_item">
        <div class="video-bab">
          <video ref="video6"
            src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/%E5%8F%AA%E9%9C%80%E8%A6%818%E6%AD%A5.mp4" autoplay
            muted style="width: 100%; height: 100%; object-fit: cover;" preload="auto">
          </video>
          <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
            <div class="text-zgai" :class="activeIndex == 14 ? 'animated-news-item' : ''">只需8步,轻松拥有专属的</div>
            <p class="zgai-font" :class="activeIndex == 14 ? 'animated-news-item' : ''">智谷AI名片</p>
          </div>
        </div>
      </swiper-slide>
      <!-- 智谷ai可以做什么15 -->
      <swiper-slide class="swiper_slide_item">
        <div class="ai-assistant-content" :class="activeIndex == 15 ? 'animated-news-item' : ''">
          <h3>智谷AI可以做什么?</h3>
          <p class="ai-description">
            智谷AI是一套全面的智能AI系统,它可以成为您工作中的得力助手,协助您完成各种任务。智谷AI,作为一款领先的人工智能助手,致力于为用户提供高效、便捷、多样化的智能服务。它凭借四大核心功能——智能对话、智能创作、角色模拟和智能绘画,为用户带来前所未有的科技体验。
          </p>
          <div class="ai-features" :class="activeIndex == 15 ? 'animated-news-item' : ''">
            <div class="ai-feature-item">
              <div class="feature-icon">
                <img src="../assets/aizndh.png" alt="智能对话">
              </div>
              <h4>智能对话</h4>
            </div>
            <div class="ai-feature-item">
              <div class="feature-icon">
                <img src="../assets/aizncz.png" alt="智能创作">
              </div>
              <h4>智能创作</h4>
            </div>
            <div class="ai-feature-item">
              <div class="feature-icon">
                <img src="../assets/aijsmn.png" alt="角色模拟">
              </div>
              <h4>角色模拟</h4>
            </div>
            <div class="ai-feature-item">
              <div class="feature-icon">
                <img src="../assets/aiznhh.png" alt="智能绘画">
              </div>
              <h4>智能绘画</h4>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 智谷AI四大功能16 -->
      <swiper-slide class="swiper_slide_item">
        <div class="video-shis"
          style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; border: none !important;">
          <video ref="video8"
            src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/3b10196e551019a506aa969305b3f143_raw.mp4" autoplay
            muted style="width: 100%; height: 100%; object-fit: contain;" preload="auto">
          </video>
          <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <div class="sd-tit" :class="activeIndex == 16 ? 'animated-news-item' : ''">智谷AI四大功能</div>
          </div>
        </div>
      </swiper-slide>
      <!-- 17-->
      <swiper-slide class="swiper_slide_item">
        <!-- 底部 -->
        <div class="card-imgs " :class="activeIndex == 17 ? 'animated-image' : ''">
          <video src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/901c15307e666d31943878a152a23e61_raw.mp4"
            autoplay muted loop style="width: 100%; height: 100%;  object-fit: contain;" preload="auto">
          </video>
          <div class="gradient-con">
            <div class="gradient-text ">链上生态互融 共享数字未来</div>
            <div class="gradient-p">智慧谷-您的企业数改服务商</div>
          </div>
        </div>
        <div class="footer" :class="activeIndex == 17 ? 'animated-image' : ''">
          <div class="footer_top">
            <!-- 左 -->
            <div class="footerTopLeft">
              <!-- 1 -->
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumps(0)">走进智慧谷</h4>
                <p @click="jumps(1)">集团介绍</p>
                <p @click="jumps(5)">发展历程</p>
                <p @click="jumps(7)">企业荣誉</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumphx(0)">核心业务</h4>
                <p @click="jumphx(5)">CHAIN企业链改服务</p>
                <p @click="jumphx(8)">企链通DAPP数商平台</p>
                <p @click="jumphx(11)">智慧谷AI名片</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumpcj(0)">应用场景</h4>
                <p @click="jumpcj(2)">数字支付</p>
                <p @click="jumpcj(3)">数字商城</p>
                <p @click="jumpcj(19)">数字三农</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumpgh(0)">合作规划</h4>
                <p @click="jumpgh(1)">合作流程</p>
                <p @click="jumpgh(2)">合作收益</p>
                <p @click="jumpgh(4)">全球战略</p>
              </div>
            </div>
            <!-- 右 -->
            <div class="footerTopRight">
              <!-- 1 -->
              <!-- <div class="RightCon" style="font-size: 20px;">
						<p style="cursor: pointer;">联系我们</p>
					</div> -->
              <div class="RightCon">
                <img src="../assets/tel.png" mode=""></img>
                <p>电话：400-8537-168</p>
              </div>
              <div class="RightCon">
                <img src="../assets/web.png" mode=""></img>
                <p style="cursor: pointer;">网址：www.gjzhg.com</p>
              </div>
              <div class="RightCon">
                <img src="../assets/email.png" mode=""></img>
                <p style="cursor: pointer;">邮箱：zhgjt@gjzhg.com</p>
              </div>
              <div class="RightCon">
                <img src="../assets/dz.png" mode=""></img>
                <p style="cursor: pointer;">地址：福建省厦门市集美区杏林湾营运中心总部大厦6号楼</p>
              </div>
              <!-- code -->
              <div class="code">
                <div style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                  <img src="../assets/gzh.jpg" alt="" style="width: 90px;height: 90px;border-radius: 10px;">
                  <h5 style="cursor: pointer;">扫一扫关注我们</h5>
                </div>
                <div style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                  <img src="../assets/kf.png" alt="" style="width: 90px;height: 90px;border-radius: 10px;">
                  <h5 style="cursor: pointer;">扫一扫添加客服</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="footer_botm">
            <p style="text-indent:1em;">版权所有：智慧谷(福建)数字科技集团有限公司</p>
            <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
            <p style="text-indent:1em;">闽ICP备16005520号-1</p>
            <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
            <p style="text-indent:1em;">本网站由阿里云提供云计算及安全服务 </p>
            <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
            <p style="text-indent:1em;"> 本网站支持 IPv6 </p>
            <p style="text-indent:1em;">|</p>
            <p style="text-indent:1em;"> Powered by CloudDream </p>
          </div>
        </div>
      </swiper-slide>
      <!-- 可选的控件 -->
      <!--分页器-->
      <div class="swiper-pagination" slot="pagination"></div>

    </swiper>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import axios from 'axios';
import NavBar from '../components/NavBar.vue';
export default {
  components: {
    NavBar
  },
  name: "FullPage",
  data() {
    return {
      activeIndex: 0,
      newsData: [],//循环新闻
      // 核心业务
      pageIndex: 0,
      businessActive: 0,
      timeoutId: null,    // 用于清除 15 秒超时的计时器
      intervalId: null,   // 用于清除自动切换 tab 的定时器
      businessList: [
        { name: '智慧谷超算公链' },
        { name: '企链通DAPP数字商城平台' },
        { name: 'PASS数据中台服务' },
        { name: 'CHAIN企业链改服务' },
        { name: '智慧谷AI芯片' },
        { name: '智慧谷全能助手' }
      ],
      // 导航栏
      topTabActive: 0,
      topTabs: [
        { name: '超算公有链智谷链' },
        { name: 'PASS数字服务平台' },
        { name: 'CHAIN企业链改服务' },
        { name: '企链通ADPP数商平台' },
        { name: '智慧谷AI名片' },
        { name: '智谷AI全能助手' },
      ],
      // swiper 配置
      swiperOption: {
        direction: "vertical", // swiper 方向
        mousewheel: true,
        // 分页器
        pagination: {
          el: ".swiper-pagination", //分页器的类名
          clickable: true, // 点击分页器跳切换到相应的幻灯片
        },
        on: {
          // 翻页
          slideChange: () => {
            // 记录当前页index
            this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex
            console.log(this.activeIndex, ' this.activeIndex')
          },
        }
      },
      // 顶部
      swiperTop: {
        direction: "horizontal", // swiper 方向
        mousewheel: true,
        // autoplay: { delay: 13000, disableOnInteraction: false },
        // 分页器
        pagination: {
          el: ".top-pagination", //分页器的类名
          clickable: true, // 点击分页器跳切换到相应的幻灯片
        },
        on: {
          // 翻页
          slideChange: () => {
            // 同步tab状态
            if (this.$refs.swiperTop && this.$refs.swiperTop.$swiper) {
              this.topTabActive = this.$refs.swiperTop.$swiper.activeIndex;
            }
          },
        }
      },
    };
  },
  mounted() {
    // 初始化定时器,开始监听
    this.autoSwitchTab();
    this.resetTimeout();
    // this.getNews();
    let that = this
    if (that.$route.query.num && that.$route.query.num != 0) {
      this.topTabActive = that.$route.query.num * 1;
      if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
        that.$refs.mySwiper.$swiper.slideTo((that.$route.query.num * 1) + 0);
        console.log((that.$route.query.num * 1) + 1);
      }
    } else {
      this.topTabActive = 0;
      if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
        that.$refs.mySwiper.$swiper.slideTo(0);
      }
    }
  },

  watch: {
    // 监听 businessActive 变量的变化
    businessActive(newVal, oldVal) {
      // 每次 businessActive 变化时,重置15秒的计时器
      clearTimeout(this.timeoutId);
      this.resetTimeout();

    },
    // 视频切换一直播放
    activeIndex(newVal, oldVal) {
      // console.log(newVal, oldVal,'ppppppp');

      if (newVal == 2) {
        let video = this.$refs.video1;  // 获取视频元素
        if (video) {
          video.currentTime = 0;  // 将视频播放时间重置为 0
          video.play();  // 播放视频
        }
      }
      // 链改服务内容
      if (newVal == 5) {
        let video = this.$refs.video2;  // 获取视频元素
        if (video) {
          video.currentTime = 0;  // 将视频播放时间重置为 0
          video.play();  // 播放视频
        }
      }

      // 第四个视频十三大解决企业痛点
      if (newVal == 6) {
        let video = this.$refs.video3;  // 获取视频元素
        if (video) {
          video.currentTime = 0;  // 将视频播放时间重置为 0
          video.play();  // 播放视频
        }
      }

      // 企链通十三大创新技术10
      if (newVal == 10) {
        let video = this.$refs.video4;  // 获取视频元素
        if (video) {
          video.currentTime = 0;  // 将视频播放时间重置为 0
          video.play();  // 播放视频
        }
      }

      //  智慧谷AI名片是什么
      if (newVal == 11) {
        let video = this.$refs.video5;  // 获取视频元素
        if (video) {
          video.currentTime = 0;  // 将视频播放时间重置为 0
          video.play();  // 播放视频
        }
      }

      //智谷AI四大功能
      if (newVal == 12) {
        let video = this.$refs.video6;  // 获取视频元素
        if (video) {
          video.currentTime = 0;  // 将视频播放时间重置为 0
          video.play();  // 播放视频
        }
      }

      // 申请智慧名片13
      if (newVal == 13) {
        let video = this.$refs.video7  // 获取视频元素
        if (video) {
          video.currentTime = 0;  // 将视频播放时间重置为 0
          video.play();  // 播放视频
        }
      }

      // 智谷AI四大功能15
      if (newVal == 15) {
        let video = this.$refs.video8  // 获取视频元素
        if (video) {
          video.currentTime = 0;  // 将视频播放时间重置为 0
          video.play();  // 播放视频
        }
      }
    },
    // 页面需要
    '$route.query.num': function (newNum) {
      // 这里是num变化时执行的操作
      let that = this
      if (that.$route.query.num != 0) {
        console.log('num changed:', newNum);
        this.topTabActive = that.$route.query.num * 1;
        console.log(that.$route.query.num)
        if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
          that.$refs.mySwiper.$swiper.slideTo((that.$route.query.num * 1) + 0);
          console.log((that.$route.query.num * 1) + 1);
        }
      } else {
        console.log('num chassssnged:', newNum);
        this.topTabActive = 0;
        if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
          that.$refs.mySwiper.$swiper.slideTo(0);
        }
      }
    }
  },
  methods: {
    // 轮播图的tab
    switchTopTab(index) {
      console.log(index);
      this.topTabActive = index;
      if (index == 0) {
        // 同步轮播图
        if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
          this.$refs.mySwiper.$swiper.slideTo(1);
        }
      } else if (index == 1) {
        // 同步轮播图
        if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
          this.$refs.mySwiper.$swiper.slideTo(3);
        }
      } else if (index == 2) {
        // 同步轮播图
        if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
          this.$refs.mySwiper.$swiper.slideTo(5);
        }
      } else if (index == 3) {
        // 同步轮播图
        if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
          this.$refs.mySwiper.$swiper.slideTo(8);
        }
      } else if (index == 4) {
        // 同步轮播图
        if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
          this.$refs.mySwiper.$swiper.slideTo(11);
        }
      } else if (index == 5) {
        // 同步轮播图
        if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
          this.$refs.mySwiper.$swiper.slideTo(15);
        }
      }

    },
    switchTab(index) {
      this.businessActive = index;
      this.pageIndex = index;
      // 清除定时器,重置 15 秒的计时
      clearTimeout(this.timeoutId);
      // 重启15秒监控
      this.resetTimeout();

      // 如果有正在进行的定时器,清除并重新启动自动切换定时器
      clearInterval(this.intervalId);
      this.autoSwitchTab();
    },

    // 自动切换 tab
    autoSwitchTab() {
      this.intervalId = setInterval(() => {
        // 自动切换到下一个 tab
        this.businessActive = (this.businessActive + 1) % this.businessList.length;
        this.pageIndex = this.businessActive;
      }, 10000); // 每 10 秒切换一次
    },

    // 监控 businessActive 的变化,如果15秒没有变化则触发 autoSwitchTab
    resetTimeout() {
      this.timeoutId = setTimeout(() => {
        this.autoSwitchTab(); // 如果15秒内没有变化,触发自动切换 tab
      }, 15000); // 15秒没有变化则触发
    },
    topOne() {
      this.$refs.mySwiper.$swiper.slideTo(0);
      this.activeIndex = 0
    },
    // 5个
    jumps(a) {
      let timestamp = Date.now();
      this.$router.replace({ name: 'IntoZhg', query: { num: a, time: timestamp } })
    },

    jumphx(a) {
      let timestamp = Date.now();
      this.$router.replace({ name: 'DevelopmentStrategy', query: { num: a, time: timestamp } })
    },

    jumpcj(a) {
      let timestamp = Date.now();
      this.$router.replace({ name: 'core', query: { num: a, time: timestamp } })
    },
    jumpgh(a) {
      let timestamp = Date.now();
      this.$router.replace({ name: 'coop', query: { num: a, time: timestamp } })
    },
    // 跳转智慧码
    jumpZh() {
      window.location.href = 'https://web-aggregation.gjwec.com'
    },
    goToExternalLink() {
      window.open('https://www.fjqlt.com/', '_blank'); // 将 'https://example.com' 替换为目标链接
    },

    gowebviews(){
      window.open('https://tk-company.gjwec.com/#/pages/webview/webview', '_blank');
    },
    goToAICard() {
      // 跳转到AI名片页面
      window.open('https://tk-company.gjwec.com/#/pages/newPage/newPage', '_blank');
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 第一个轮播图视频 */
.textara {
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 26%;
  transform: translate(-50%, -50%);
  height: auto;
  flex-direction: column;
  color: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-cons {
  font-size: 65px;
  padding-bottom: 20px;
}

.text-fonts {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 20px;
  /* text-align: left; */
  /* border: 1px solid; */
  margin-right: 40px;
}

.but-tex {
  background: linear-gradient(90deg, #34e5fd 0%, #db9bfe 100%);
  border-radius: 50px;
  /* box-shadow: '0px 4px 8px rgba(52, 229, 253, 0.5), 0px 8px 16px rgba(219, 155, 254, 0.5)'; */
  color: #fff;
  width: 230px;
  position: absolute;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  bottom: 340px;
  cursor: pointer;
  left: 150px;
}

/* 导航栏颜色 */
.top-business-con {
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: center;
}

.top-business-con .tab-nav {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 0;
  background: rgba(255, 255, 255, 0.5);
  padding: 15px;
  border-radius: 50px;
}

.top-business-con .tab-item {
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-size: 16px;
  color: #2c3e50;
}

.top-business-con .tab-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #333;
}

.top-business-con .tab-item.active {
  background: linear-gradient(90deg, #BFE9FF 0%, #D6E2FF 100%);
  color: #2D7CFE;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.01);
  border-radius: 50px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .top-business-con {
    bottom: 80px;
    padding: 0 20px;
  }

  .top-business-con .tab-nav {
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px;
  }

  .top-business-con .tab-item {
    font-size: 14px;
    padding: 8px 15px;
  }
}

@media (max-width: 480px) {
  .top-business-con .tab-nav {
    gap: 5px;
    padding: 8px;
  }

  .top-business-con .tab-item {
    font-size: 12px;
    padding: 6px 12px;
  }

  .strategy-container {
    padding: 0 10px;
  }

  .strategy-row {
    gap: 10px;
  }

  .strategy-item {
    min-height: 220px;
  }

  .strategy-item.expanded {
    min-height: 300px;
  }

  .strategy-icon {
    width: 50px;
    height: 50px;
  }

  .strategy-icon img {
    width: 30px;
    height: 30px;
  }

  .strategy-title {
    font-size: 14px;

  }

  .strategy-subtitle {
    font-size: 10px;
  }

  .strategy-content {
    font-size: 11px;
    padding: 5px;
    min-height: 60px;
  }

  .expand-icon {
    bottom: 5px;
  }

  .expand-icon img {
    width: 20px;
    height: 20px;
  }
}

/* 顶部按钮 */
.top-nav {
  width: 40px;
  height: 40px;
  position: fixed;
  right: 0em;
  top: 285px;
  z-index: 1000;
  cursor: pointer;
  transition: all 0.3s ease;
}

.top-nav:hover {
  transform: scale(1.1);
}

#mySwiper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.swiper-pagination {
  right: 1em;
}

/* 四个轮播 */
/* 配置分页器的颜色 */
#swiperTop {
  --swiper-pagination-color: #ffffff;
  /* 未选中状态颜色为白色 */
  --swiper-pagination-current-color: #0000ff;
  /* 选中状态颜色为蓝色 */
}

/* 如果想要分页器小圆点的大小和样式进行微调 */
.swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.swiper-pagination-bullet-active {
  background-color: #0000ff;
  /* 选中的小圆点颜色为蓝色 */
}

.top-pagination {
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.top-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  margin: 0 5px;
  background: #fff;
  opacity: 1;
  transition: all 0.3s ease;
}

.top-pagination .swiper-pagination-bullet-active {
  background: #fff;
  opacity: 0.5;
}

/* 超算公谷链1 */
.one-card {
  width: 100%;
  height: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  padding-top: 80px;
}

.card-Tit {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  font-size: 33px;
  font-weight: bold;
  color: #333;
}

.card-font {
  color: #A7A9AC;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
}

/* 从左往右 */
.animated-title {
  animation: slideInFromLeft 0.8 ease-out forwards;
  transform: translateX(-100%);
}

@keyframes slideInFromLeft {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.animated-content {
  animation: slideInFromLeftContent 0.8s ease-out forwards;
  transform: translateX(-100%);
  opacity: 0;
}

@keyframes slideInFromLeftContent {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 超算共谷 */
.bigCards {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  padding: 20px;
  margin-top: 100px;
}

.tab-pane-content {
  display: flex;
  gap: 24px;
  min-width: 600px;
  align-items: center;
  justify-content: flex-end;
  padding-left: 100px;
  padding-right: 100px;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  justify-content: space-around;
}

.feature-item {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  width: 100%;
  padding: 5px;
}

.feature-header {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 5px;
  margin-bottom: 8px;
}

.feature-item img {
  width: 32px;
  height: 32px;
}

.feature-item h4 {
  color: #000;
  font-size: 18px;
  margin: 0;
}

.feature-item p {
  color: #9EACBC;
  font-size: 14px;
  margin: 0;
  line-height: 2;
  margin-left: 5px;
}

.right-image-content {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 20px;
}

.right-image-content img {
  max-width: 100%;
  max-height: 440px;
  object-fit: contain;
}


/* 新加 */
.passBigs {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  border-radius: 15px;
  margin-top: 100px;
}


.pass-font {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}



/* PASS数字服务平台 */
.passBig {
  background-image: url('../assets/passbacks.png');
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 15px;
  overflow: hidden;
  flex-direction: column;
}

.bigSz {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border-radius: 12px;
  padding: 20px 0;
}

.bigSz img {
  width: 80%;
  height: auto;
  display: block;
}

.pass-font {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}


/* 多系统融合数字生态服务 */
.reds-tit {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 120px;
  font-size: 33px;
  font-weight: bold;
  color: #333;
}

.leftbgc {
  background-image: url('../assets/cszz.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 500px;
  height: 600px;
  text-align: center;
  color: #fff;
}

.rediceItem-content {
  padding-left: 60px;
  padding-right: 60px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100px;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-top: 100px;
}


.rediceItem-content-notice {
  font-size: 17px;
  color: #032C6D;
  text-align: start;
  align-items: center;
  display: flex;
  padding-top: 20px;
  padding-bottom: 20px;
}

.rediceItem-content-round {
  font-size: 7px;
  color: #032C6D;
  margin-right: 10px;
}

.leftbgc p {
  margin-top: 40px;
  font-size: 22px;
}

.left-font {
  margin-top: 50px;
  color: #032C6D;
}

.left-font ul li::marker {
  color: #032C6D;
}

.left-font ul {
  padding-left: 20px;
  list-style-type: disc;
}

.left-font ul {
  padding-left: 20px;
  list-style-type: disc;
}

.left-font ul li {
  height: 40px;
}

/* 右边蓝色 */
.rightBgc {
  background-image: url('../assets/csright.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 520px;
  height: 600px;
  text-align: center;
  color: #032C6D;

}

.rightBgc p {
  font-size: 22px;
  color: #fff;
}

.right-font {
  margin-top: 50px;
}

.rediceItem-content-titles {
  display: flex;
  padding-top: 15px;
}

.rediceItem-content-notices {
  font-size: 22px;
  padding-top: 15px;
  height: 60px;
}

.rediceItem-contents {
  padding-left: 60px;
  padding-right: 60px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 22px;
}

.rediceItem-content-notices {
  font-size: 17px;
  color: #fff;
  width: 100%;
  text-align: start;
  align-items: center;
  display: flex;
}

.rediceItem-content-rounds {
  font-size: 7px;
  color: #fff;
  margin-right: 10px;
}

.rightBgc p {
  margin-top: 40px;
  font-size: 22px;
}

.rightBgc-font {
  margin-top: 50px;
  color: #fff;
}

.rightBgc-font ul li::marker {
  color: #fff;
}

.rightBgc-font ul {
  padding-left: 20px;
  list-style-type: disc;
}

.rightBgc-font ul {
  padding-left: 20px;
  list-style-type: disc;
}

.rightBgc-font ul li {
  height: 40px;
}


/* 企链通简介 */
.aixt-con {
  background: url('../assets/aixtback.png') no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
}


.aixt-con {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.ai-fon {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 100px;
}

.xt-ft {
  font-size: 33px;
  font-weight: bold;
  color: #333;
}

.xt-txt {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  font-size: 18px;
  color: #A7A9AC;
}


/* 5.0 */
.aixt-big {
  background: url('../assets/shus.png') no-repeat center center;
  background-size: contain;
  /* 保证图片完整展示 */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  min-height: 520px;
  box-sizing: border-box;
  border-radius: 24px;
  margin-top: 150px;
  padding: 0 40px;
  height: 700px;
}

.aixt-left,
.aixt-right {
  flex: 1 1 0;
  max-width: 800px;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 340px;
  box-sizing: border-box;
}


/* 动画效果查看更多 */
.more-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  color: #0066FF;
  font-size: 16px;
  cursor: pointer;
  padding: 8px 16px;
  /* margin-top: 30px; */
  overflow: hidden;
  height: 50px;
  /* border: 1px solid; */
  position: absolute;
  bottom: 80px;
  left: 0;
}

.more-btn::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 160px;
  /* 减小宽度 */
  height: 160px;
  /* 减小高度 */
  background: linear-gradient(90deg, #0066FF, #2196F3 20%);
  z-index: -2;
  animation: rotate1 1.3s linear infinite;
  transform-origin: 0 0;
}

.more-btn::after {
  content: '';
  position: absolute;
  left: 2px;
  /* 减小间距 */
  top: 2px;
  /* 减小间距 */
  width: calc(100% - 4px);
  /* 调整宽度 */
  height: calc(100% - 4px);
  /* 调整高度 */
  background: #fff;
  z-index: -1;
}

.more-btn .arrow {
  animation: arrow-move 5s infinite;
}

@keyframes rotate1 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes arrow-move {

  0%,
  100% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(4px);
  }
}

.aixt-left {
  padding-left: 0px;
  border: none;
}

.aixt-left img {
  width: 65%;
  height: 450px;
  object-fit: cover;
  border-radius: 8px;
}

.aixt-right {
  flex-direction: column;
  margin-right: 80px;
  text-indent: 2em;
  width: 400px;
}

.aixt-tit {
  font-size: 32px;
  font-weight: bold;
  color: #222;
  text-align: center;
  margin-bottom: 24px;
  margin-right: 80px;
}

.aixt-font {
  font-size: 17px;
  color: #666;
  min-height: 248px;
  text-align: left;
  word-break: break-all;
  line-height: 1.8;
}

/* 链改服务内容 */
.video-ref {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.video-ref video {
  width: 70vw;
  height: 80vh;
  object-fit: cover;
}

.video-overlay {
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.reform-con {
  color: #333;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  padding-top: 30px;
}


/* 十三大解决企业 */
.video-td {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-td video {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
}

.video-tds {
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  flex-direction: column;
}

.td-con {
  color: #333;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
}

.td-tit {
  color: #A7A9AC;
}


/* 链改服务 */
.lg-fuwu {
  width: 100%;
  margin-top: 120px;
}

.lg-font {
  color: #333;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
}

.lg-bigs {
  background-image: url('../assets/lgbigs.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 80vw;
  min-width: 80vw;
  display: flex;
  justify-content: center;
  position: relative;
  margin-left: 10%;
  align-items: center;
  margin-top: 140px;
  height: 500px;
}

.lg-zi {
  /* border: 1px solid red; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.lg-zi img {
  /* 设置图片的高度为容器的80% */
  min-width: 100px;
  max-width: 280px;
  opacity: 0;
  transform: scale(0.5);
  animation-fill-mode: forwards;
  animation-duration: 0.8s;
  animation-timing-function: ease-out;
  /* border: 1px solid; */
}

.fade-in-1 {
  animation-name: fadeInImage;
  animation-delay: 0.2s;
  animation-play-state: running;
}

.fade-in-2 {
  animation-name: fadeInImage;
  animation-delay: 0.6s;
  animation-play-state: running;
}

.fade-in-3 {
  animation-name: fadeInImage;
  animation-delay: 1s;
  animation-play-state: running;
}

.fade-in-4 {
  animation-name: fadeInImage;
  animation-delay: 1.4s;
  animation-play-state: running;
}

.fade-in-5 {
  animation-name: fadeInImage;
  animation-delay: 1.8s;
  animation-play-state: running;
}


@keyframes fadeInImage {
  from {
    opacity: 0;
    transform: scale(0.5);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 900px) {
  .lg-bigs img {
    width: 22%;
    min-width: 60px;
    max-width: 120px;
  }

  .lg-bigs {
    gap: 1vw;
  }
}

/* 新闻动画效果 - 从左往右 */
.animated-news-item {
  animation: slideInFromLeftNews 0.8s ease-out forwards;
  transform: translateX(-100%);
  opacity: 0;
}

@keyframes slideInFromLeftNews {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 上排证书从左向右动画 - 居中对齐 */
.animated-cert-left {
  animation: slideInFromLeftCert 1s ease-out forwards;
  transform: translateX(-100%);
  opacity: 0;
}

@keyframes slideInFromLeftCert {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 下排证书整体从右向左动画 */
.animated-bottom-row {
  animation: slideInFromRightRow 1s ease-out forwards;
  transform: translateX(100%);
  opacity: 0;
}

@keyframes slideInFromRightRow {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}



/* 生态合作伙伴样式 */
.ecology {
  width: 100%;
  height: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.partner-container {
  width: 100%;
  max-width: 1500px;
  display: flex;
  flex-direction: column;
}

.partner-row {
  display: flex;
  justify-content: space-between;
  opacity: 0;
  gap: 60px;
}

.partner-item {
  flex: 1;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  transition: transform 0.6s ease;
}

/* .partner-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
} */

.partner-item img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.animated-image {
  animation: slideInFromRight 0.8s ease-out forwards;
  transform: translateX(100%);
  opacity: 0;
}

@keyframes slideInFromRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 合作伙伴动画 */
.animated-partner-row {
  animation: slideInFromLeft 1s ease-out forwards;
}

.animated-partner-row-delay1 {
  animation: slideInFromRight 1s ease-out forwards;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .partner-container {
    margin-top: 40px;
    gap: 20px;
  }

  .partner-row {
    flex-wrap: wrap;
    gap: 15px;
  }

  .partner-item {
    flex: 0 0 calc(33.33% - 10px);
    height: 60px;
  }
}

@media (max-width: 480px) {
  .partner-item {
    flex: 0 0 calc(50% - 8px);
    height: 50px;
    padding: 10px;
  }
}




/* 底部导航栏 */
.footer {
  width: 100%;
  height: 340px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  color: #000;
  position: absolute;
  bottom: 0;
}

.footer_top {
  width: 100%;
  height: 300px;
  border-bottom: 1px solid #fff;
  display: flex;
  justify-content: center;
  padding-top: 30px;

}

.footerTopLeft {
  width: 50%;
  height: 210px;
  display: flex;
  justify-content: space-around;
  /* border: 1px solid; */
  margin-top: 20px;
}

.LeftCon p {
  font-size: 27rpx;
  text-align: center;
  color: #989898;
  cursor: pointer;
  line-height: 2.5;
}

.LeftCon h4 {
  color: #000;
  text-align: center;
  cursor: pointer;
  font-size: 18px;
}

.RightCon p {
  color: #989898;
  cursor: pointer;
}

/* 右边四个 */
.footerTopRight {
  height: 240px;
  font-size: 14px;
  position: relative;
  left: 3%;
  width: 40%;
}

.RightCon {
  height: 18%;
  display: flex;
  align-items: center;
}

.RightCon img {
  width: 25px;
  height: 25px;
  margin-right: 15px;
}

.RightCon p {
  color: #000;
  margin: 0;
  line-height: 25px;
}

.footerMidd {
  width: 70%;
  height: 75%;
  border-bottom: 1px solid #cacaca;
}

.code {
  position: absolute;
  right: 18%;
  top: 0;
  width: 35%;
  align-items: center;
  justify-content: space-around;
  display: flex;
}

.codes {
  width: 23%;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.codes img {
  width: 100%;
  height: 100%;
}

.code h5 {
  margin-top: 10px;
}

.footer_botm {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  font-size: 16px;

}


/* 图片动画 - 从右往左居中 */
.card-imgs {
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0;
  object-fit: fill;
  position: relative;
}

.vjs-custom-skin {
  width: 100%;
  height: 100%;
}

.video-js {
  width: 100% !important;
  height: 100% !important;
  min-height: 300px;
}

.video-js video {
  object-fit: cover;
}

/* 响应式布局调整 */
@media (max-width: 768px) {
  .card-imgs {
    max-width: 100%;
    margin-right: 0;
  }

  .card-imgs .video-js {
    min-height: 250px;
  }
}

.gradient-con {
  position: absolute;
  margin-top: -380px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.gradient-text {
  font-size: 70px;
  /* 设置字体大小 */
  font-weight: bold;
  /* 可选的加粗 */
  background: linear-gradient(90deg, #30EDFC 0%, #304EFC 100%);
  -webkit-background-clip: text;
  /* Safari和Chrome支持 */
  background-clip: text;
  /* 适用于Firefox */
  color: transparent;
  /* 使文字透明,从而显示背景渐变 */
  padding-bottom: 30px;
}

.gradient-p {
  font-size: 40px;
  /* 设置字体大小 */
  font-weight: bold;
  color: #fff;
}


/* 新闻活动应用场景 */
.swiper_slide_item {
  position: relative;
  height: 100%;
}

.video-container {
  position: relative;
  height: 100%;
  overflow: hidden;

}

.text-overlay {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #333;
  font-size: 28px;
  font-weight: bold;
  padding-top: 100px;
}



/* 智谷链 */
.video-containers {
  position: relative;
  height: 100%;
  overflow: hidden;

}

.text-overlays {
  position: absolute;
  top: 100px;
  /* left: 50%; */
  transform: translateX(-50%);
  color: #333;
  font-size: 28px;
  font-weight: bold;
}

.subtitle {
  position: absolute;
  top: 150px;
  /* left: 50%; */
  transform: translateX(-50%);
  color: #A7A9AC;
  font-size: 20px;
}


/* 生态合作伙伴 */
.qlt-sd {
  width: 100%;
  margin-top: 100px;
}

.qlt-Tit {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-size: 28px;
  font-weight: bold;
  width: 100%;
}

.qlt-big {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  margin-top: 100px;
}

.qlt-row {
  width: 65%;
  display: flex;
  justify-content: space-around;
  margin-bottom: 24px;
}

.qlt-back {
  width: 220px;
  height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  background-image: url('../assets/qlted.png');
  background-repeat: no-repeat;
  background-size: contain;
  padding-left: 10px;
  padding-right: 10px;
}

.qlt-img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  position: absolute;
  top: -40px;
}

.qlt-txt {
  font-size: 24px;
  font-weight: bold;
  background: linear-gradient(270deg, #43FFF5 0%, #2D7CFE 100%);
  -webkit-background-clip: text;
  color: transparent;
  /* 确保文字是透明的,渐变色才能应用 */
  margin-bottom: 8px;
  text-align: center;
  padding-top: 60px;
  padding-bottom: 20px;
}

.qlt-con {
  font-size: 15px;
  color: #9EACBC;
  text-align: center;
  line-height: 1.5;
  word-break: break-all;
  padding-left: 20px;
  padding-right: 20px;
  text-align: left;
}

@media (max-width: 900px) {
  .qlt-row {
    flex-direction: column;
    align-items: center;
  }

  .qlt-back {
    width: 90vw;
    margin: 12px 0;
    height: auto;
  }
}


/* 企链通十三大创新技术 */
.video-st {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 420px;
  background-color: #F9FAFB;
}

.video-st video {
  display: block;
  margin: 0 auto;
  width: 85%;
  height: 85%;
  object-fit: cover;
  margin-top: 30px;
}

.text-overlays {
  margin-top: 10px;
  font-size: 28px;
  color: #333333;
  font-weight: bold;
  text-align: center;
}

/* 智慧谷AI名片是什么? */
.video-zgai {
  position: relative;
  height: 100%;
  overflow: hidden;
  /* padding-top: 10px; */
}

.zgaish {
  position: absolute;
  top: 100px;
  /* left: 50%; */
  transform: translateX(-50%);
  color: #333;
  font-size: 28px;
  font-weight: bold;
}

.zgai-tex {
  position: absolute;
  top: 180px;
  /* left: 50%; */
  transform: translateX(-50%);
  color: #606972;
  font-size: 18px;
  width: 50%;
  text-indent: 2em;
}

.view-more-btn {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.view-more-btn:hover {
  background-color: #0056b3;
}

/* 新加 */
.new-slide-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 10%;
  margin-top: 100px;
}

.new-slide-title {
  color: #333;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  width: 100%;
}

.new-slide-text {
  color: #606972;
  font-size: 18px;
  line-height: 1.8;
  text-align: justify;
  max-width: 1100px;
  margin: 0 auto;
  text-indent: 2em;
}

.new-con {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  margin: 40px auto 0;
  gap: 20px;
}

.new-two {
  display: flex;
  justify-content: space-around;
  width: 100%;
  gap: 20px;
}

.new-two img {
  width: calc(46% - 10px);
  height: auto;
  object-fit: contain;
}

.view-more-link {
  color: #0066FF;
  cursor: pointer;
  text-decoration: none;
  display: inline;
  white-space: nowrap;
}

.view-more-link:hover {
  text-decoration: none;
}

.zgaishs {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 120px;
  color: #333;
  font-size: 28px;
  font-weight: bold;
}

.zgai-texs {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #606972;
  font-size: 18px;
  width: 70%;
}


/* AI名片查看更多按钮 */
.view-more-btn-aicard {
  align-items: center;
  justify-content: center;
  /* gap: 8px; */
  padding: 12px 28px;
  /* background:#EFF7FE; */
  /* background: transparent;  */
  color: #0066FF;
  /* font-size: 18px; */
  font-weight: 500;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  border: none;
}



.view-more-btn-aicard .arrow-right {
  font-size: 20px;
  animation: arrow-bounce 2s infinite;
}

@keyframes arrow-bounce {

  0%,
  100% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(3px);
  }
}

/* 8步 */
.video-bab {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.text-zgai {
  position: absolute;
  top: 100px;
  /* left: 50%; */
  transform: translateX(-50%);
  color: #333;
  font-size: 28px;
  font-weight: bold;
}

.zgai-font {
  position: absolute;
  top: 150px;
  /* left: 50%; */
  transform: translateX(-50%);
  color: #2155FE;
  font-size: 20px;
}

/* 申请智慧名片 */
.video-zhmp {
  position: relative;
  height: 100%;
  padding-top: 30px;
}


/* 智谷ai可以做什么 */
/* 智慧谷全能助手 */
.ai-assistant-content {
  text-align: center;
  margin-top: 120px;
}

.ai-assistant-content h3 {
  font-size: 30px;
  color: #333;
  margin-bottom: 30px;
}

.ai-description {
  font-size: 23px;
  color: #666;
  line-height: 2;
  margin: 0 auto 40px;
  max-width: 1300px;
  text-align: justify;
  text-indent: 2em;
}

.ai-features {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 40px;
}

.ai-feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.feature-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
}

.feature-icon img {
  width: 300px;
  height: 300px;
}

.ai-feature-item h4 {
  font-size: 19px;
  color: #333;
  margin: 0;
}


/* 四大 */
/* 四大功能模块样式 */
.video-shis {
  position: relative;
  height: 100%;
  overflow: hidden;
  border: none !important;
}

.sd-tit {
  position: absolute;
  top: 100px;
  /* left: 50%; */
  transform: translateX(-50%);
  color: #333;
  font-size: 28px;
  font-weight: bold;
}


/* 十三大 */
.video-shisan {
  position: relative;
  height: 100%;
  overflow: hidden;
  padding-top: 10px;
  background-color: #F9FAFB;
}

.sd-tit {
  position: absolute;
  top: 100px;
  transform: translateX(-50%);
  color: #333;
  font-size: 28px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/dev.vue